module.exports = "https://coursera_assets.s3.amazonaws.com/images/25b197c2368b61842cad47da794fb191.png";